import React from "react";
import FilterCard from "./FilterCard";
import OutputFilesTable from "./OutputFilesTable";
import OutputFileTile from "./OutputFileTile";
import sampleData from "./sampleData.json";
import { Formik, Field } from "formik";
import { useDeepEffect, useRequest } from "../../abstracts";
import { getOutputFiles } from "../../services/outputFiles";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroller";

const OUTPUT_FILES_OFFSET = 20;

function OutputFilesContainer(props) {
  const [stopLoading, setStopLoading] = useState(false);
  const [TotalCount, setTotalCount] = useState(0);
  const [response, setResponse] = useState([]);
  const [plans, setPlans] = useState([]);
  const [request, setRequest] = useState({
    from: 0,
    offset: OUTPUT_FILES_OFFSET,
    trigger: true,
  });
  useDeepEffect(() => {
    getOutputFiles({
      ...request,
    }).then((result) => {
      setTotalCount(result.totalCount);
      if (result?.outputFile.length < OUTPUT_FILES_OFFSET) setStopLoading(true);
      setResponse([...response, ...result.outputFile]);
    });
  }, [request]);

  return (
    <Formik
      initialValues={{
        searchTerm: "",
        fromDate: null,
        toDate: null,
        filterValue: 0,
      }}
      onSubmit={() => {}}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => (
        <div
          className="w-100"
          style={{
            padding: "0rem 1rem",
          }}
        >
          <div className="mt-3 mb-4">Output Page</div>
          <hr className="w-100" />
          <FilterCard
            values={values}
            setFieldValue={setFieldValue}
            FileResponse={response}
            FileCount={response?.length}
            totalcount={TotalCount}
            className="w-100"
            setStopLoading={setStopLoading}
            request={request}
            setRequest={setRequest}
            setResponse={setResponse}
            setPlans={setPlans}
          />
          {/* <OutputFilesTable /> */}
          {response.length > 0 ? (
            <div className="tile-container">
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  setRequest({
                    ...request,
                    from: response.length,
                  });
                }}
                hasMore={!stopLoading}
                initialLoad={false}
                threshold={300}
                useWindow={false}
                loader={
                  stopLoading ? null : (
                    <div className="loader" key={0}>
                      Loading ...
                    </div>
                  )
                }
              >
                {response?.map((file, index) => {
                  return (
                    <OutputFileTile key={index} data={file} plans={plans} />
                  );
                })}
              </InfiniteScroll>
            </div>
          ) : (
            <div className="no-record">No records found</div>
          )}
        </div>
      )}
    </Formik>
  );
}

export default OutputFilesContainer;
